import React, { useState, useCallback } from 'react';
import { FormSpy } from 'react-final-form';
import { withStyles } from '@material-ui/core/styles';

import FormTitleBar from '../../core/components/FormTitleBar';
import NavigationPrompt from '../../core/components/NavigationPrompt';
import { removePathEnd, getInitials } from '../../core/utils';
import LeaveConfirm from '../../core/components/LeaveConfirmWrapper';
import { Edit, FormTab, TabbedForm } from 'react-admin';
import EditToolbar from '../../core/components/edit/EditToolbar';

import FundTermsSummary from './FundTermsSummary';
import FundTermsRelations from './FundTermsRelations';

const styles = () => ({
  noActions: {
    marginTop: '0px'
  }
});

const FundTermsTitle = ({ record }) => {
  return (
    <FormTitleBar
      name={record.name}
      showAvatar
      avatarContent={getInitials(record.name)}
    />
  );
};

const FundTermsEdit = props => {
  const {
    classes,
    hasCreatePermission,
    hasEditPermission,
    hasReadPermission,
    hasDeletePermission,
    userProfile,
    ...rest
  } = props;
  const [whenBlockNavigation, setWhenBlockNavigation] = useState(false);

  const handleFormIsDirty = useCallback(
    dirty => {
      // Block navigation when the form is dirty
      setWhenBlockNavigation(dirty);
    },
    [setWhenBlockNavigation]
  );

  const displayToolbar = props.match.isExact;

  return (
    <React.Fragment>
      <NavigationPrompt
        when={whenBlockNavigation}
        adjustMatchingPath={removePathEnd}
        hasEditPermission={hasEditPermission}
      >
        {(isOpen, onConfirm, onCancel) => (
          <LeaveConfirm
            isOpen={isOpen}
            onConfirm={onConfirm}
            onClose={onCancel}
          />
        )}
      </NavigationPrompt>
      <Edit
        {...rest}
        record={{
          description: ''
        }}
        undoable={false}
        title={<FundTermsTitle />}
        classes={{ noActions: classes.noActions }}
      >
        <TabbedForm
          toolbar={
            displayToolbar ? (
              <EditToolbar
                {...rest}
                hasEditPermission={hasEditPermission}
                hasDeletePermission={hasDeletePermission}
                //onBeforeDelete={this.onBeforeDelete}
              />
            ) : (
              <></>
            )
          }
          variant="standard"
          margin="normal"
        >
          <FormTab label="Summary">
            <FormSpy
              subscription={{ dirty: true }}
              onChange={props => {
                handleFormIsDirty(props.dirty);
              }}
            />
            <FundTermsSummary />
          </FormTab>
          <FormTab label="Related Funds">
            {/** cutting props from the formTab because a fixed width class was given to the child, and making the list smaller*/}
            <>
              <FundTermsRelations {...rest} />
            </>
          </FormTab>
        </TabbedForm>
      </Edit>
    </React.Fragment>
  );
};

export default withStyles(styles)(FundTermsEdit);
